export default __webpack_public_path__ + "static/bg-mobile-43a578c3047d3ac183a51dce47901142.png";